import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import API from "../../../Services/BaseService";
import Loading from "../../../Component/Loading/Loading";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import Popup from "../../../Component/Popup/Popup";
import ls from 'local-storage';
import ViewSellerNotesPopup from './ViewSellerNotesPopup';
import ViewIfInfoPopup from './ViewIfInfoPopup';
import ViewTitlePopup from './ViewTitlePopup';
import ViewBuyerNotesPopup from './ViewBuyerNotesPopup';
import ViewArb from './ViewArb';
import ViewPSi from './ViewPSi';
import { useDispatch, useSelector } from 'react-redux';
import printJS from 'print-js';
import LogoImg from '../../../../src/assets/img/Logo_final.png';
import PageNotFound from '../../FallBackUI/PageNotFound';
import Barcode from "react-barcode";
import barcode from '../../../assets/img/barcode.svg';
import moment from 'moment';

const ViewBillofSale = (props) => {

    const history = useHistory();
    const billOfSaleId = ls.get("billOfSaleId")
    const [BOSList, setBOSList] = useState("");
    const [loading, setLoading] = useState(true);
    const { BillofSale, CarId } = props.location.state;
    console.log("check the props value for the bill of sale", props.location.state);
    // console.log("check the bill of sale",CarId);
    console.log("check the bill of salwe id in props", props.location.state);
    const [lights, setLights] = useState("");
    const [title, setTitle] = useState("");
    const [enterTitle, setEnterTitle] = useState("");
    const [efficientRadio, setefficientRadio] = useState("");
    const successData = useSelector(state => state.LoginReducer.payload);

    const [isView, setIsView] = useState(false);
    const [notesId, setNotesId] = useState("");
    const [notesName, setNotesName] = useState("");
    const [bosId, setBosId] = useState("");
    const [billofsale, setBillofsale] = useState("");
    console.log(billofsale, "billofsale")
    const [car, setCar] = useState("");
    // console.log(CarId,"carId")
    const [writeoffchargeSeller, setWriteoffchargeSeller] = useState("");
    const [data, setdata] = useState("");

    const [isViewIF, setIsViewIF] = useState(false);
    const [ifId, setIfId] = useState("");
    const [isViewTitle, setIsViewTitle] = useState(false);
    const [titleId, setTitleId] = useState("");
    const [isViewBuyer, setIsViewBuyer] = useState(false);
    const [isViewArb, setIsViewArb] = useState(false);
    const [arbId, setArbId] = useState("");
    const [isViewPsi, setIsViewPsi] = useState(false);
    const [psiId, setPsiId] = useState("");
    const [psiAmt, setPsiAmt] = useState("");
    const [sellerCarChargesId, setSellerCarChargesId] = useState("");
    const [sellerFeesDetails, setSellerFeesDetails] = useState("")
    const [sellerMailLogId, setSellerMailLogId] = useState("");

    const [registrationFee, setRegistrationFee] = useState("");
    const [sFloatFee, setSFloatFee] = useState("");
    const [noTitleFee, setNoTitleFee] = useState("");
    const [miscFee, setMiscFee] = useState("");
    const [bidPrice, setBidPrice] = useState("");
    const [totalSoldAmt, setTotalSoldAmt] = useState("");
    const [specialtyFee, setSpecialtyFee] = useState("");
    const [payToSeller, setPayToSeller] = useState("");
    const [carCharges, setCarCharges] = useState("");
    const [payCharges, setPayCharges] = useState("");
    const [type, setType] = useState("");
    const [buyerPayCharges, setBuyerPayCharges] = useState("");
    const [buyerFeeTotal, setBuyerFeeTotal] = useState("");
    const [sellerFeeTotal, setSellerFeeTotal] = useState("");
    const [miscSeller, setMiscSeller] = useState("");
    const [SellersFee, setSellersFee] = useState("");

    const [floorSeller, setFloorSeller] = useState("");
    const [docSeller, setDocSeller] = useState("");
    const [reserveFee, setReserveFee] = useState("");
    const [extraAmtSeller, setExtraAmtSeller] = useState("");
    const [minimumSeller, setMinimumSeller] = useState("");

    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isShown, setIsShown] = useState(false);


    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    console.log(sellerCarChargesId, "sellerCarChargesId")

    const backUrl = ls.get("backredirection");
    console.log("check the back url", backUrl);
    const back = backUrl[(backUrl.length) - 1];
    console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);

    const togglePopup = () => {
        setIsOpen(!isOpen);
    };


    const toggleViewNotesPopup = (data) => {
        setBosId(data?.bill_of_sale_id);
        setNotesId(data?.seller_notes_id);
        setNotesName(data?.seller_notes);
        setIsView(!isView);
    }
    const toggleViewIFPopup = (data) => {
        setIfId(data?.if_info)
        setIsViewIF(!isViewIF);
    }
    const toggleViewTitlePopup = (data) => {
        setCar(data?.car_id)
        setdata(data?.bill_of_sale_id)
        setTitleId(data?.enter_title)
        setIsViewTitle(!isViewTitle);
    }
    const toggleViewBuyerNotesPopup = (data) => {
        setBosId(data?.bill_of_sale_id);
        setNotesId(data?.seller_notes_id);
        setNotesName(data?.seller_notes);
        setIsViewBuyer(!isViewBuyer);
    }
    const toggleViewArbPopup = (data) => {
        setBosId(data?.bill_of_sale_id);

        setArbId(data?.arb)
        setIsViewArb(!isViewArb);
    }

    const toggleViewPsiPopup = (data) => {
        setBosId(data?.bill_of_sale_id);

        setPsiId(data?.psi)
        setPsiAmt(data?.psi_amount)
        setIsViewPsi(!isViewPsi);
    }
    const config = {
        background: "#f5f5f5",
        displayValue: false,
        marginTop: "20px",
        marginBottom: "20px",
        fontOptions: "italic",
        width: 2,
        heigth: 5,
    };

    const redirectSellercheck = () => {
        history.push({ pathname: "/SellerCheck", state: { billofsale: billofsale, car: car, sellerCarChargesId: sellerCarChargesId, type: BOSList.voidpayment_status } });
        console.log("billofsaleId checking ======", billofsale);
        console.log("car id checking======", car);

    };

    const reCallFunction = () => {
        console.log("reCallFunction")
        titleView()
        billofSaleView()
    }

    const mailLogAddSeller = (sellermaillogid) => {
        history.push({ pathname: "/maillogview", state: {} });
        ls.set("maillogid", sellermaillogid);
        console.log("sellermaillogid======", sellermaillogid);
        // setMailSell("true")
    };

    const billofSaleView = () => {

        let request = {
            bill_of_sale_id: BillofSale,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token
        }
        console.log("request", request);

        API.post("billofsaleById/condition", request).then(response => {

            console.log("gatepass_list Details response", response.data?.data)
            if (response.data.success === true) {
                setBOSList(response.data?.data[0]);
                setLights(response.data?.data[0]?.Lights);
                setTitle(response.data?.data[0]?.Title);
                setefficientRadio(response.data?.data[0]?.mileage_status);
                setSellerCarChargesId(response.data.data[0]?.seller_car_charges_id);
                console.log("testing charge id", response.data.data[0]?.seller_car_charges_id)
                setCar(response.data.data[0]?.car_id);
                setBillofsale(response.data.data[0]?.bill_of_sale_id)
                setSellerMailLogId(response.data.data[0]?.sellermaillogid);
                setPayCharges(response.data.data[0]?.pay_charges);
                setWriteoffchargeSeller(response.data.data[0]?.WriteOff_seller_pay_charges);

                setRegistrationFee(response.data.data[0]?.seller_registration_fee);
                setSFloatFee(response.data.data[0]?.seller_float_fee);
                setNoTitleFee(response.data.data[0]?.seller_no_title_fee);
                setSpecialtyFee(response.data.data[0]?.seller_specialty_fee);
                setFloorSeller(response.data.data[0]?.seller_floor_cc_fee);
                setDocSeller(response.data.data[0]?.seller_document_fee);
                setReserveFee(response.data.data[0]?.seller_reserve_fee);
                setMiscSeller(response.data.data[0]?.misc_seller_fee);
                setMinimumSeller(response.data.data[0]?.seller_minimum_net);
                setExtraAmtSeller(response.data.data[0]?.extra_amount_toadd_toseller_fee);
                setBidPrice(response.data.data[0]?.seller_car_price);
                setSellersFee(response.data.data[0]?.seller_fee);

                setMiscFee(response.data.data[0]?.misc_fee);

                let sellerChargesAmt = 0
                for (let i = 0; i < response.data.data[0]?.sellerfeechargeslist.length; i++) {
                    sellerChargesAmt += parseInt(response.data.data[0]?.sellerfeechargeslist[i].billofsale_sellerfee_chargeamount);
                    // console.log("sellAmt",sellAmt);
                    setTotalSoldAmt(sellerChargesAmt)
                }


            }
            else {
                setErrors(response.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const titleView = () => {

        let request = {
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
            car_id: CarId,
            bill_of_sale_id: BillofSale,

        }
        API.post("entertitle_view/condition", request).then((response) => {
            console.log("mailBankAccount", response.data.data);
            if (response.data.success === true) {
                setEnterTitle(response.data?.data);
                //   setLights(response.data.data[0]?.payment_status);
                //   setLoading(false)
            }
            else {
                setErrors(response.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    };

    const getSellerIfPrivileges = () => {
        console.log("getSellerIfPrivileges")
        togglePopup()
        setPopupMsg("Seller doesn't have Payment Status");
        setPopupActionType("close");
        setPopupActionValue("ok");
    }

    const viewDefaultSelList = () => {
        let request = {
            seller_dealer_id: successData.seller_dealer_id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token
        }
        API.post("specialfeeseller/condition", request).then(response => {
            console.log("seller default", response.data.data)
            if (response.data.success === true) {
                setSellerFeesDetails(response.data.data);
                setLoading(false);
            }
            else {
                setErrors(response.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    useEffect(() => {
        viewDefaultSelList()
        titleView()
    }, [])

    useEffect(() => {
        billofSaleView();
    }, [BillofSale])

    const printPage = (data) => {
        // console.log("print")
        printJS({
            printable: "pdfPrint",
            type: 'html',
            targetStyles: ['*'],
            documentTitle: "BillofSale"
        })
    }


    const totalAmtSeller =
        Number(bidPrice) -
        (Number(SellersFee) +
            Number(totalSoldAmt) +
            // Number(registrationFee) +
            // Number(floorSeller) +
            // Number(docSeller) +
            // Number(reserveFee) +
            // Number(sFloatFee) +
            // Number(noTitleFee) +
            Number(writeoffchargeSeller) +
            Number(miscFee) +
            // Number(specialtyFee) +
            // Number(miscSeller) +
            // Number(minimumSeller) +
            // Number(extraAmtSeller == -1 ? sellerFeesDetails.extra_amount_toadd_toseller_fee : extraAmtSeller) +
            // Number(sellerExtraAmount) +
            Number(payCharges)

        );
    console.log("seller Fee amount", bidPrice, SellersFee, totalSoldAmt, writeoffchargeSeller, miscFee, payCharges)

    console.log("totalAmtSeller", Number(bidPrice),
        Number(SellersFee),
        Number(totalSoldAmt),
        Number(miscFee),
        Number(writeoffchargeSeller),
        Number(payCharges)
    );

    console.log(BOSList.checkseller, BOSList.achnoid, "chevckseller")


    const redirectsoldpage = (carId) => {
        history.push({
            pathname: "/soldcardetails",
            state: { id: carId },
        });
        ls.set("backredirection", [...backUrl, "/billofsale"])
        // ls.set("BillofSaleId", BillofSale)
    };

    const handleBackButton = (carId) => {

        history.push({
            pathname: back,
            state: { id: carId },
        });
        ls.set("backredirection", backUrl.slice(0, -1))

    }

    const redirectSellerDealer = (bill_of_sale_id, car_id) => {
        history.push({
            pathname: "/manageaccount",
            state: { BillofSale: bill_of_sale_id, CarId: car_id },
        });
        ls.set("backredirection", [...backUrl, "/billofsale"])
        ls.set("BillofSaleId", bill_of_sale_id);
        ls.set("BillOfSaleCarId", car_id)
    };

    const redirectSeller = (bill_of_sale_id, car_id) => {
        history.push({
            pathname: "/myprofile",
            state: { BillofSale: bill_of_sale_id, CarId: car_id },
        });
        ls.set("backredirection", [...backUrl, "/billofsale"])
        ls.set("BillofSaleId", bill_of_sale_id);
        ls.set("BillOfSaleCarId", car_id)
    };

    function formatTime(value) {
        if (!value) {
            return '';
        }
        let local = ""
        let offset = ""
        local = new Date(value);
        offset = local.getTimezoneOffset();
        value = new Date(local.getTime() - offset * 60000);
        value = moment(value).format('MMMM D, YYYY hh:mm A')
        return value;
    }

    const handleSellerCheckRedirect = () => {
        history.push({ pathname: "/SellerCheck", state: { billofsale: billofsale, car: car, sellerCarChargesId: sellerCarChargesId } });

    }

    return (


        <main id="main" className="inner-page">
            <div class="container-fluid inner-page-space billof-sec">
                <div class="common-heading">
                    <div className="row">
                        <div className="col-lg-4">
                            <div class="back-btn">
                                <a class="back-btn-primary" onClick={() => handleBackButton(BOSList?.car_id)}>
                                    <i class="bx bx-chevron-left"></i> Back
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div class="title">
                                <p class="inner-title">View Bill of Sale</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div class='download-btn'>
                                <div class="downBtn ">
                                    <i class="icofont-file-pdf "></i>
                                    <button className="printBtn mb-12" type="button" onClick={() => printPage()}>Download</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {errorFlag === true ? <PageNotFound error={errors} /> :
                    <div class="billofsale-sec">
                        <div class="row">
                            <div className='col-sm-12'> <h4>Bill of Sale info</h4> </div>
                            <div class="col-md-6 col-lg-4 form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="BillofSale#" defaultValue={BOSList?.bill_of_sale_id} disabled />
                                    <label for="BillofSale#" class="input-has-value">Bill Of Sale #</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox bos-g-pass">
                                    <label for="BillofSale#" class="input-has-value">
                                        Gate Pass #
                                    </label>
                                    <input
                                        type="text"
                                        class="textbox"
                                        id="BillofSale#"
                                        defaultValue={BOSList?.gatepass_code}
                                        disabled
                                    />
                                </div>
                                {BOSList?.gatepass_code ?
                                    <>
                                        <span className="bp-qr-codeview">

                                            <img
                                                className=''
                                                src={barcode}
                                                alt=""
                                                onMouseEnter={() => setIsShown(true)}
                                                onMouseLeave={() => setIsShown(false)}
                                            />{" "}
                                        </span>

                                        {isShown && (
                                            <div className="barCodeDiv">
                                                <Barcode
                                                    value={BOSList?.gatepass_code}
                                                    {...config}
                                                />
                                            </div>
                                        )}
                                    </> : ""}
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" placeholder="" defaultValue={BOSList?.enter_title} disabled />
                                    <label for="Gate_Pass#" class="input-has-value">Title #</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" placeholder="" defaultValue={BOSList?.sales_type} disabled />
                                    <label for="Gate_Pass#" class="input-has-value">Sales Type</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" placeholder="" defaultValue={formatTime(BOSList?.solddate_tz)} disabled />
                                    <label for="SoldDate" class="input-has-value">Sold Date</label>
                                </div>
                            </div>
                            <div className='col-sm-12'> <h4>Auto Information</h4> </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox hyperlink" id="Inventory#" defaultValue={BOSList?.car_id}
                                        onClick={() => redirectsoldpage(BOSList?.car_id)} />
                                    <label for="Inventory#" class="input-has-value">Inventory #</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox hyperlink" id="vin"
                                        defaultValue={BOSList?.vin_no}
                                        onClick={() => redirectsoldpage(BOSList?.car_id)} />
                                    <label for="vin" class="input-has-value">Vin #</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="Make" defaultValue={BOSList?.make} disabled />
                                    <label for="Make" class="input-has-value">Make</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="Model" defaultValue={BOSList?.model} disabled />
                                    <label for="Model" class="input-has-value">Model</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="Year" defaultValue={BOSList?.year} disabled />
                                    <label for="Year" class="input-has-value">Year</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="Color" defaultValue={BOSList?.color} disabled />
                                    <label for="Color" class="input-has-value">Color</label>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="efficient" defaultValue={BOSList?.efficient} disabled />
                                    <label for="efficient" class="input-has-value">Efficient</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="Body" defaultValue={BOSList?.body} disabled />
                                    <label for="Body" class="input-has-value">Body</label>
                                </div>

                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="deliveryinfo" defaultValue={BOSList?.car_delievery_info} disabled />
                                    <label for="deliveryinfo" class="input-has-value">Car Delivery Info</label>
                                </div>

                            </div>

                            <div class="col-md-3 col-lg-2  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="Mileage" defaultValue={BOSList?.mileage} disabled />
                                    <label for="Mileage" class="input-has-value">Mileage</label>
                                </div>

                            </div>
                            <div class="col-md-3 col-lg-2  form-group tboxes-miles">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="Miles/Kms" defaultValue={BOSList?.mileage_type} disabled />
                                    <label for="Miles/Kms" class="input-has-value">Miles/Kms</label>
                                </div>

                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="Odometer" defaultValue={BOSList?.odometer} disabled />
                                    <label for="Odometer" class="input-has-value">Odometer</label>
                                </div>

                            </div>
                            <div className='col-sm-12'>
                                <h4>Seller Information</h4>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="search" id="seller" class={BOSList?.seller_color == "pink"
                                        ? "tableRowPink textbox hyperlink"
                                        : BOSList?.seller_color == "Silver"
                                            ? "tableRowSilver textbox hyperlink"
                                            : BOSList?.seller_color == "Orange"
                                                ? "tableRowOrange textbox hyperlink"
                                                : BOSList?.seller_color == "Navy blue"
                                                    ? "tableRowNavyBlue textbox hyperlink"
                                                    : BOSList?.seller_color == "firered"
                                                        ? "tableRowFireRed textbox hyperlink"
                                                        : BOSList?.seller_color == "Purple"
                                                            ? "tableRowPurple textbox hyperlink"
                                                            : BOSList?.seller_color == "Yellow"
                                                                ? "tableRowYellow1 textbox hyperlink"
                                                                : BOSList?.seller_color == "green"
                                                                    ? "tableRowGreenColor textbox hyperlink"
                                                                    : BOSList?.seller_color == "blue"
                                                                        ? "tableRowBlue textbox hyperlink"
                                                                        : BOSList?.seller_color == "darkred"
                                                                            ? "tableRowRed1 textbox hyperlink"
                                                                            : "textbox hyperlink"} onClick={() => redirectSeller(BOSList?.bill_of_sale_id, BOSList?.car_id)}
                                        aria-label="Recipient's username" aria-describedby="button-addon2" defaultValue={BOSList?.seller_id} />
                                    <label for="seller" class="input-has-value">Seller#</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class={BOSList?.seller_color == "pink"
                                        ? "tableRowPink textbox hyperlink"
                                        : BOSList?.seller_color == "Silver"
                                            ? "tableRowSilver textbox hyperlink"
                                            : BOSList?.seller_color == "Orange"
                                                ? "tableRowOrange textbox hyperlink"
                                                : BOSList?.seller_color == "Navy blue"
                                                    ? "tableRowNavyBlue textbox hyperlink"
                                                    : BOSList?.seller_color == "firered"
                                                        ? "tableRowFireRed textbox hyperlink"
                                                        : BOSList?.seller_color == "Purple"
                                                            ? "tableRowPurple textbox hyperlink"
                                                            : BOSList?.seller_color == "Yellow"
                                                                ? "tableRowYellow1 textbox hyperlink"
                                                                : BOSList?.seller_color == "green"
                                                                    ? "tableRowGreenColor textbox hyperlink"
                                                                    : BOSList?.seller_color == "blue"
                                                                        ? "tableRowBlue textbox hyperlink"
                                                                        : BOSList?.seller_color == "darkred"
                                                                            ? "tableRowRed1 textbox hyperlink"
                                                                            : "textbox hyperlink"} onClick={() => redirectSeller(BOSList?.bill_of_sale_id, BOSList?.car_id)}
                                        id="Name" defaultValue={BOSList?.sellerName} />
                                    <label for="Name" class="input-has-value">Seller Name</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class={BOSList?.sellerdealercolor == "pink"
                                        ? "tableRowPink textbox hyperlink"
                                        : BOSList?.sellerdealercolor == "Silver"
                                            ? "tableRowSilver textbox hyperlink"
                                            : BOSList?.sellerdealercolor == "Orange"
                                                ? "tableRowOrange textbox hyperlink"
                                                : BOSList?.sellerdealercolor == "Navy blue"
                                                    ? "tableRowNavyBlue textbox hyperlink"
                                                    : BOSList?.sellerdealercolor == "firered"
                                                        ? "tableRowFireRed textbox hyperlink"
                                                        : BOSList?.sellerdealercolor == "Purple"
                                                            ? "tableRowPurple textbox hyperlink"
                                                            : BOSList?.sellerdealercolor == "Yellow"
                                                                ? "tableRowYellow1 textbox hyperlink"
                                                                : BOSList?.sellerdealercolor == "green"
                                                                    ? "tableRowGreenColor textbox hyperlink"
                                                                    : BOSList?.sellerdealercolor == "blue"
                                                                        ? "tableRowBlue textbox hyperlink"
                                                                        : BOSList?.sellerdealercolor == "darkred"
                                                                            ? "tableRowRed1 textbox hyperlink"
                                                                            : "textbox hyperlink"} onClick={() => redirectSellerDealer(BOSList?.bill_of_sale_id, BOSList?.car_id)}
                                        id="organization" defaultValue={BOSList?.seller_dealer_name} />
                                    <label for="organization" class="input-has-value">Dealer Name</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="dealertype" defaultValue={BOSList?.seller_organisation} disabled />
                                    <label for="dealertype" class="input-has-value">Dealer Type</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="License#" defaultValue={BOSList?.sellerlicense} disabled />
                                    <label for="License#" class="input-has-value">License#</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="address" defaultValue={BOSList?.address} disabled />
                                    <label for="address" class="input-has-value">Address</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="state" defaultValue={BOSList?.seller_state_name} disabled />
                                    <label for="state" class="input-has-value">State</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="text" class="textbox" id="city" defaultValue={BOSList?.seller_city_name} disabled />
                                    <label for="city" class="input-has-value">City</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="number" class="textbox" id="zip" defaultValue={BOSList?.seller_zipcode} disabled />
                                    <label for="zip" class="input-has-value">Zip code</label>
                                </div>
                            </div>

                            <div class="col-md-12 col-lg-12 mb-4 mt-2 flex-wrap d-flex justify-content-start">
                                <button type="button" class="btn btn-dark me-2" onClick={() => toggleViewNotesPopup(BOSList)}>Seller notes</button>
                                {(BOSList.check_seller == null || BOSList.check_seller == "") && (BOSList.achno_id == null || BOSList.achno_id == "") ?
                                    <button type="button" class="btn btn-dark me-2" onClick={() => toggleViewIFPopup(BOSList)}  >IF Info</button> : ""}
                                {BOSList.enter_title_id == null ? "" :
                                    <button type="button" class="btn btn-dark me-2"
                                        onClick={() => { /* enterTitle[0]?.payment_status == null ? getSellerIfPrivileges() : */ redirectSellercheck(billofsale) }} >{BOSList.voidpayment_status == "Ach" ? "Seller ACH" : "Seller Check"}</button>}
                                {/* <button type="button" class="btn btn-dark me-2" onClick={() => history.push('/sellercheck')} >Seller Check</button> */}
                                <button type="button" class="btn btn-dark me-2" onClick={() => toggleViewTitlePopup(BOSList)} >Enter Title</button>
                                {(BOSList.check_seller == null || BOSList.check_seller == "") && (BOSList.achno_id == null || BOSList.achnoid == "") ?
                                    "" :
                                    <button type="button" class="btn btn-dark me-2" >Deliver Check</button>}

                                {BOSList.enter_title_id == null ?
                                    <button type="button" class="btn btn-dark me-2" >Car Charges</button> : ""}
                                {(BOSList.check_seller == null || BOSList.check_seller == "") && (BOSList.achno_id == null || BOSList.achno_id == "") ? "" :
                                    <button type="button" class="btn btn-dark me-2" onClick={() => mailLogAddSeller(sellerMailLogId)} >Mail Log</button>
                                }

                            </div>

                            <div className='col-sm-12'>
                                <h4>Buyer Information</h4>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group"><div class="tbox"><input type="text" class="textbox" placeholder="" defaultValue={BOSList?.buyer_id} disabled /><label for="Gate_Pass#" class="input-has-value">Buyer #</label></div></div>
                            <div class="col-md-6 col-lg-4  form-group"><div class="tbox"><input type="text" class="textbox" placeholder="" defaultValue={BOSList?.buyerName} disabled /><label for="Gate_Pass#" class="input-has-value">Buyer Name</label></div></div>
                            <div class="col-md-6 col-lg-4  form-group"><div class="tbox"><input type="text" class="textbox" placeholder="" defaultValue={BOSList?.buyer_dealer_name} disabled /><label for="Gate_Pass#" class="input-has-value">Dealer Name</label></div></div>
                            <div class="col-md-6 col-lg-4  form-group"><div class="tbox"><input type="text" class="textbox" placeholder="" defaultValue={BOSList?.buyer_organisation} disabled /><label for="Gate_Pass#" class="input-has-value">Dealer Type</label></div></div>
                            <div class="col-md-6 col-lg-4  form-group"><div class="tbox"><input type="text" class="textbox" placeholder="" defaultValue={BOSList?.buyerlicense} disabled /><label for="Gate_Pass#" class="input-has-value">License</label></div></div>
                            <div class="col-md-6 col-lg-4  form-group"><div class="tbox"><input type="text" class="textbox" placeholder="" defaultValue={BOSList?.buyer_address} disabled /><label for="Gate_Pass#" class="input-has-value">Address</label></div></div>
                            <div class="col-md-6 col-lg-4  form-group"><div class="tbox"><input type="text" class="textbox" placeholder="" defaultValue={BOSList?.buyer_state_name} disabled /><label for="Gate_Pass#" class="input-has-value">State</label></div></div>
                            <div class="col-md-6 col-lg-4  form-group"><div class="tbox"><input type="text" class="textbox" placeholder="" defaultValue={BOSList?.buyer_city_name} disabled /><label for="Gate_Pass#" class="input-has-value">City</label></div></div>
                            <div class="col-md-6 col-lg-4  form-group"><div class="tbox"><input type="text" class="textbox" placeholder="" defaultValue={BOSList?.buyer_zipcode} disabled /><label for="Gate_Pass#" class="input-has-value">Zipcode</label></div></div>
                            <div class="col-md-12 col-lg-12 mb-4 mt-2 flex-wrap d-flex justify-content-start">
                                <button type="button" class="btn btn-dark me-2" onClick={() => toggleViewBuyerNotesPopup(BOSList)} disabled >Buyer notes</button>
                                <button type="button" class="btn btn-dark me-2" onClick={() => toggleViewArbPopup(BOSList)} disabled >Arb</button>
                                {/* <button type="button" class="btn btn-dark me-2" onClick={() => toggleViewPsiPopup(BOSList)} disabled>PSI</button>
                                        <button type="button" class="btn btn-dark me-2" disabled>Apply Pmt</button>
                                        <button type="button" class="btn btn-dark me-2" disabled>Floor/CC Pmt</button> */}
                                <button type="button" class="btn btn-dark me-2" disabled>Gate pass</button>
                                {/* <button type="button" class="btn btn-dark me-2" disabled>Mail Log</button> */}
                                <button type="button" class="btn btn-dark me-2" disabled>Deliver Title</button>
                            </div>

                            <div class="mb-2 col-md-6 col-lg-4"><h5 class="text-color">Lights</h5>
                                <div class="radio input-group"><input id="radio-btn1" type="radio" value="Any" checked={BOSList.Lights == "As is" ? true : false} /><label for="radio-btn1" class="radio-label">As is</label></div>

                                <div class="radio input-group"><input id="radio-btn2" type="radio" value="Any" checked={lights == "With Conditions" ? true : false} /><label for="radio-btn2" class="radio-label">With Conditions</label></div>
                                <div class="radio input-group"><input id="radio-btn3" type="radio" value="Any" checked={lights == "Auction guarantee" ? true : false} /><label for="radio-btn3" class="radio-label">Actutation guarantee</label></div>
                            </div>

                            <div class="mb-2 col-md-6 col-lg-4"><h5 class="text-color">Title</h5>
                                <div class="radio input-group"><input id="radio-btn4" type="radio" value="Any" checked={title == "Title" ? true : false} /><label for="radio-btn4" class="radio-label">Title</label></div>

                                <div class="radio input-group"><input id="radio-btn5" type="radio" value="Any" checked={title == "Title Attached" ? true : false} /><label for="radio-btn5" class="radio-label">Title Attached</label></div>
                                <div class="radio input-group"><input id="radio-btn6" type="radio" value="Any" checked={title == "Bill of sale only" ? true : false} /><label for="radio-btn6" class="radio-label"> Bill of sale only</label></div>
                            </div>
                            <div class="mb-2 col-md-6 col-lg-4"><h5 class="text-color">Mileage</h5>
                                <div class="radio input-group"><input id="radio-btn7" type="radio" value="Any" checked={efficientRadio == "Actual" ? true : false} /><label for="radio-btn7" class="radio-label">Actual</label></div>

                                <div class="radio input-group"><input id="radio-btn8" type="radio" value="Any" checked={efficientRadio == "Exceeds Mechanical Limit" ? true : false} /><label for="radio-btn8" class="radio-label">Exceeds Mechanical Limit</label></div>
                                <div class="radio input-group"><input id="radio-btn9" type="radio" value="Any" checked={efficientRadio == "Unknown (TMU)" ? true : false} /><label for="radio-btn9" class="radio-label">UnKnown(TMU)</label></div>
                                <div class="radio input-group"><input id="radio-btn9" type="radio" value="Any" checked={efficientRadio == "Exempt" ? true : false} /><label for="radio-btn9" class="radio-label">Exempt</label></div>

                            </div>

                            <div className='col-sm-12'> <h4>Seller Fee</h4> </div>

                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="number" class="textbox" id="MiscFee" value={BOSList?.seller_car_price} disabled />
                                    <label for="MiscFee" class="input-has-value">Bid Price</label>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="number" class="textbox" id="SellersFee " value={BOSList?.seller_fee} disabled />
                                    <label for="SellersFee" class="input-has-value">Seller's Fee</label>
                                </div>
                            </div>
                            {sellerFeesDetails?.length > 0 ? sellerFeesDetails.map((sellerFeesDetails, index) =>

                                <div class="col-md-6 col-lg-4  form-group">
                                    <div class="tbox">
                                        <input type="number" class="textbox" id="SellersFee " defaultValue={sellerFeesDetails?.seller_special_fee_amount} disabled />
                                        <label for="SellersFee" class="input-has-value" title={sellerFeesDetails?.special_fee_seller_name}> {sellerFeesDetails?.special_fee_seller_name}</label>
                                    </div>
                                </div>) : ""}



                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="number" class="textbox" id="MiscFee" value={miscFee == -1 ? sellerFeesDetails.misc_seller_fee : miscFee} disabled />
                                    <label for="MiscFee" class="input-has-value">Miscellaneous fee</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="number" class="textbox" id="MiscFee" value={BOSList?.pay_charges} disabled />
                                    <label for="MiscFee" class="input-has-value">Car Charges</label>
                                </div>
                            </div>

                            {(BOSList.entertitlemethod == "check" || BOSList.entertitlemethod == "ach") && BOSList.amtpaidfortitleseller !== null ? <>

                                <div class="col-md-6 col-lg-4  form-group">
                                    <div class="tbox">
                                        <input type="number" class="textbox" id="TotalAmt1" value={BOSList?.amtpaidfortitleseller} disabled />
                                        <label for="TotalAmt1" class="input-has-value">Seller Charges</label>
                                    </div>
                                </div>
                            </> : ""}
                            <div class="col-md-6 col-lg-4  form-group">
                                <div class="tbox">
                                    <input type="number" class="textbox" id="PaytoSeller" value={(BOSList.checkseller == null || BOSList.checkseller == "") && (BOSList.achnoid == null || BOSList.achnoid == "") ? totalAmtSeller : BOSList.pay_to_seller} disabled />
                                    <label for="PaytoSeller" class="input-has-value">Pay to Seller</label>
                                </div>
                            </div>
                        </div>



                        <div>
                            <div className='hideContent bospdf'>
                                <div className='row' id="pdfPrint">
                                    <div className='col-lg-4 col-md-4 col-sm-4 col-4' style={{ "padding": "20px" }}>
                                        <img src={LogoImg} ></img>
                                    </div>
                                    <div className='col-lg-4 col-md-4 col-sm-4 col-4 pdf-fontSize' style={{ "marginLeft": "150px", "marginTop": "50px", "fontSize": "20px" }}><h1>Bill Of Sale</h1></div>
                                    <div className=''>

                                        <div className='row'>
                                            <div className='col-sm-12'>
                                                <div class="tbox pdf-header-Line">
                                                    <strong><h4 className='pdf-fontSize'>Bill of Sale info</h4></strong>
                                                </div>
                                            </div>

                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4"><div class="tbox">Bill Of Sale # : {BOSList?.bill_of_sale_id}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4"><div class="tbox">Gate Pass # : {BOSList?.gatepass_code}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4"><div class="tbox">Title # : {BOSList?.enter_title}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4"><div class="tbox"> {BOSList.achno_id !== null ? "ACH Number" : BOSList.check_seller !== null ? "Check Number" : "Check/ACH"} : {BOSList.ach_no !== null ? BOSList.ach_no : BOSList.check_seller !== null ? BOSList.check_seller : ""}</div></div>
                                            <div className='col-sm-12'>
                                                <div class="tbox pdf-header-Line">
                                                    <strong><h4 className='pdf-fontSize'>Auto Information</h4></strong>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Inventory # : {BOSList?.car_id} </div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Vin # : {BOSList?.vin_no}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Model : {BOSList?.model} </div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Year : {BOSList?.year} </div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Color : {BOSList?.color} </div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Make : {BOSList?.make} </div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Efficient : {BOSList?.efficient} </div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Body : {BOSList?.body} </div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Car Delivery Info : {BOSList?.car_delievery_info} </div></div>
                                            <div className='col-sm-12'>
                                                <div class="tbox pdf-header-Line">
                                                    <strong><h4 className='pdf-fontSize'>Seller Information</h4></strong>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Seller # : {BOSList?.seller_dealer_id}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Name : {BOSList?.seller_dealer_name}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Organization : {BOSList?.sellerName}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Dealer Type : {BOSList?.seller_organisation}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">License : {BOSList?.sellerlicense}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Address : {BOSList?.address}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">State : {BOSList?.seller_state_name}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">City : {BOSList?.seller_city_name}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Zipcode : {BOSList?.seller_zipcode}</div></div>
                                            <div className='col-sm-12'>
                                                <div class="tbox pdf-header-Line">
                                                    <strong><h4 className='pdf-fontSize'>Buyer Information</h4></strong>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Buyer #: {BOSList?.buy}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Name : {BOSList?.buyer_dealer_name}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Organization : {BOSList?.buyerName}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Dealer Type : {BOSList?.buyer_organisation}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">License : {BOSList?.buyerlicense}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Address : {BOSList?.buyer_city_name}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">State : {BOSList?.buyer_state_name}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">City : {BOSList?.buyer_city_name}</div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Zipcode : {BOSList?.buyer_zipcode}</div></div>
                                            <table class="border-0" style={{ "marginLeft": "20px", "width": "1000px", "border": "none" }}>
                                                <tbody>
                                                    <tr style={{ "border": "none" }}>
                                                        <td class="border-0" style={{ "width": "240px", "border": "none" }}>
                                                            <p><strong>Lights</strong></p>
                                                        </td>
                                                        <td style={{ "width": "223px", "border": "none" }}>
                                                            <p><strong>Title</strong></p>
                                                        </td>
                                                        <td style={{ "width": "200px", "border": "none" }}>
                                                            <p><strong>Efficient</strong></p>
                                                        </td>
                                                    </tr>
                                                    <tr style={{ "border": "none" }}>
                                                        <td style={{ "width": "240px", "border": "none" }}><input id="radio-btn1" type="radio" value="Any" checked={lights == "As is" ? true : false} /> As is</td>
                                                        <td style={{ "width": "223px", "border": "none" }}><input id="radio-btn1" type="radio" value="Any" checked={title == "Yes" ? true : false} /> Yes</td>
                                                        <td style={{ "width": "200px", "border": "none" }}><input id="radio-btn1" type="radio" value="Any" checked={efficientRadio == "Actual" ? true : false} /> Actual</td>
                                                    </tr>
                                                    <tr style={{ "border": "none" }}>
                                                        <td style={{ "width": "240px", "border": "none" }}><input id="radio-btn1" type="radio" value="Any" checked={lights == "With Conditions" ? true : false} /> With Conditions</td>
                                                        <td style={{ "width": "223px", "border": "none" }}><input id="radio-btn1" type="radio" value="Any" checked={title == "Delayed (TA)" ? true : false} /> Delayed(TA)</td>
                                                        <td style={{ "width": "200px", "border": "none" }}><input id="radio-btn1" type="radio" value="Any" checked={efficientRadio == "Exceeds Mechanical Limit" ? true : false} /> Over(Exceeds)</td>
                                                    </tr>
                                                    <tr style={{ "border": "none" }}>
                                                        <td style={{ "width": "240px", "border": "none" }}><input id="radio-btn1" type="radio" value="Any" checked={lights == "Auction guarantee" ? true : false} /> Actutation guarantee</td>
                                                        <td style={{ "width": "223px", "border": "none" }}><input id="radio-btn1" type="radio" value="Any" checked={title == "No" ? true : false} /> No</td>
                                                        <td style={{ "width": "200px", "border": "none" }}><input id="radio-btn1" type="radio" value="Any" checked={efficientRadio == "Unknown (TMU)" ? true : false} /> UnKnown(TMU)</td>
                                                    </tr>
                                                    <tr style={{ "border": "none" }}>
                                                        <td style={{ "width": "240px", "border": "none" }}> </td>
                                                        <td style={{ "width": "223px", "border": "none" }}> </td>
                                                        <td style={{ "width": "200px", "border": "none" }}><input id="radio-btn10" type="radio" value="Any" checked={efficientRadio == "Exempt" ? true : false} /> Exempt</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className='col-sm-12'>
                                                <div class="tbox pdf-header-Line">
                                                    <strong><h4 className='pdf-fontSize'>Seller Fee</h4></strong>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Seller Fee : {BOSList?.seller_fee} </div></div>

                                            {sellerFeesDetails.length > 0 ? sellerFeesDetails.map((sellerFeesDetails) =>
                                                <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group">
                                                    <div class="tbox pdf-line">
                                                        {sellerFeesDetails?.special_fee_seller_name} : {sellerFeesDetails?.seller_special_fee_amount}

                                                    </div>
                                                </div>
                                            ) : ""}

                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Miscellaneous Fee : {miscFee == -1 ? sellerFeesDetails.misc_seller_fee : miscFee} </div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Car Charges : {BOSList?.pay_charges} </div></div>
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4  form-group"><div class="tbox pdf-line">Pay to Seller : {BOSList?.pay_to_seller}</div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {isOpen && (
                            <CommonPopup
                                handleClose={togglePopup}
                                popupTitle={popupTitle}
                                popupMsg={popupMsg}
                                popupType={popupType}
                                popupActionType={popupActionType}
                                popupActionValue={popupActionValue}
                                popupActionPath={popupActionPath}
                            />
                        )}
                    </div>}
                {isView && <Popup
                    isClose={false}
                    content={<>
                        <ViewSellerNotesPopup toggle={toggleViewNotesPopup} notesId={notesId} notesName={notesName} bosId={bosId} />
                    </>}
                    handleClose={toggleViewNotesPopup}
                />}
                {isViewIF && <Popup
                    isClose={false}
                    content={<>
                        <ViewIfInfoPopup toggle={toggleViewIFPopup} viewIfId={ifId} />
                    </>}
                    handleClose={toggleViewIFPopup}
                />}
                {isViewTitle && <Popup
                    isClose={false}
                    content={<>
                        <ViewTitlePopup toggle={toggleViewTitlePopup} titleId={titleId} car={car} BosId={data}reCallFunction={reCallFunction} />
                    </>}
                    handleClose={toggleViewTitlePopup}
                />}
                {isViewBuyer && <Popup
                    isClose={false}
                    content={<>
                        <ViewBuyerNotesPopup toggle={toggleViewBuyerNotesPopup} notesId={notesId} notesName={notesName} bosId={bosId} />
                    </>}
                    handleClose={toggleViewBuyerNotesPopup}
                />}
                {isViewArb && <Popup
                    isClose={false}
                    content={<>
                        <ViewArb toggle={toggleViewArbPopup} viewArbId={arbId} bosId={bosId} />
                    </>}
                    handleClose={toggleViewArbPopup}
                />}

                {isViewPsi && <Popup
                    isClose={false}
                    content={<>
                        <ViewPSi toggle={toggleViewPsiPopup} psiAmt={psiAmt} bosId={bosId} psiId={psiId} />
                    </>}
                    handleClose={toggleViewPsiPopup}
                />}

            </div>

        </main>
    )
}
export default ViewBillofSale;